import { WalletPaginatorInterface } from '../../models/wallet.paginator.interface';

export interface WalletInterfaceState {
  wallet: WalletPaginatorInterface;
}

export const initialWalletState: WalletInterfaceState = {
  wallet: null
};
